<div class="modal-header">
    <span class="modal-title">{{ "TIME_WINDOW_SUGGESTIONS_HEADER" | translate }}</span>
    <button type="button" class="close" [disabled]="handlingSuggestions" (click)="dismissModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div class="container-flex">
        <div class="info-text">
            {{ 'TIME_WINDOW_SUGGESTIONS_INFO' | translate }}
        </div>
        <app-table
            data-qa="qa-time-window-suggestions"
            customClass="patient-time-window-table"
            [loadingItems]="loading"
            [loadingTable]="handlingSuggestions"
        >
            <ng-container header>
                <th class="flex-1">{{ "ID" | translate }}</th>
                <th class="flex-2">{{ "CLIENT" | translate }}</th>
                <th class="flex-3">{{ "DESCRIPTION" | translate }}</th>
                <th class="flex-2">{{ "CURRENT_TIME_WINDOW" | translate }}</th>
                <th class="flex-2">{{ "PROPOSED_TIME_WINDOW" | translate }}</th>
                <th class="flex-1 justify-content-center">{{ "PERMANENT" | translate }}</th>
                <th class="flex-1 justify-content-center">
                    <app-checkbox [(ngModel)]="selectAll" (change)="toggleSelectionAll(suggestions)"></app-checkbox>
                </th>
            </ng-container>
            <ng-container body>
                @for (suggestion of suggestions; track suggestion) {
                    <tr (click)="toggleSelection(suggestion, $event)">
                        <td class="flex-1">
                            <span appTitleProvider>{{ suggestion.patientId }}</span>
                        </td>
                        <td class="flex-2">
                            <span appTitleProvider>{{ suggestion.patientName }}</span>
                        </td>
                        <td class="flex-3">
                            <span appTitleProvider>{{ suggestion.taskDescription }}</span>
                        </td>
                        <td class="flex-2">
                            <span appTitleProvider>{{ suggestion.originalStartTime }}
                                - {{ suggestion.originalEndTime }}</span>
                        </td>
                        <td class="flex-2" appTitleProvider>
                            <span>{{ suggestion.proposedStartTime }} - {{ suggestion.proposedEndTime }}</span>
                        </td>
                        <td class="flex-1 justify-content-center">
                            <span
                                [ngClass]="{
                                'vismaicon vismaicon-sm vismaicon-no-hover vismaicon-filled vismaicon-success':
                                    suggestion.permanent,
                                'icon-unchecked icon-unchecked-sm': !suggestion.permanent
                            }"
                            ></span>
                        </td>
                        <td class="flex-1 justify-content-center">
                            <app-checkbox [id]="suggestion.taskId" [ngModel]="suggestion.checked"></app-checkbox>
                        </td>
                    </tr>
                }
            </ng-container>
        </app-table>
    </div>
</div>

<div class="modal-footer">
    <button
        type="button"
        id="secondary"
        class="btn btn-secondary"
        [disabled]="handlingSuggestions"
        (click)="dismissModal()"
    >
        {{ 'CANCEL' | translate }}
    </button>

    <div class="right-container">
        <button
            type="button"
            class="btn btn-default"
            translate="BUTTON_REJECT_SELECTED"
            [disabled]="disableButtons"
            (click)="handleSuggestions(suggestions)"
        ></button>
        <button
            data-qa="qa-accept-button"
            type="button"
            class="btn btn-primary"
            translate="BUTTON_ACCEPT_SELECTED"
            [disabled]="disableButtons"
            (click)="handleSuggestions(suggestions, true)"
        ></button>
    </div>
</div>
